import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export function convertTimezonedDateToIsoAtMidnight(date: Date | string) {
  return dayjs(date).utc(true).startOf('day').toDate()
}

export function convertTimezonedEndDateToIsoEndOfDay(date: Date) {
  return dayjs(date).utc(true).endOf('day').toDate()
}

export function convertIsoToTimezonedDate(date: Date | string | number) {
  let _date: string
  if (date instanceof Date) {
    _date = date.toISOString()
  } else {
    _date = new Date(date).toISOString()
  }
  return new Date(_date.slice(0, -1))
}

export function convertIsoToTimezonedEndDate(date: Date | string | number) {
  let _date: string
  if (date instanceof Date) {
    _date = date.toISOString()
  } else {
    _date = new Date(date).toISOString()
  }
  return dayjs(_date.slice(0, -1)).endOf('day').toDate()
}

export function convertIsoDateArrayToTimezonedDate<T extends { date: string }>(
  values?: T[] | undefined,
): T[] {
  if (!values || values.length === 0) {
    return []
  }
  return values.map((value) => ({
    ...value,
    date: convertIsoToTimezonedDate(value.date).toISOString(),
  }))
}

export function convertTimezonedToIsoWithOneMonthStartOfDay(
  date: Date | string,
) {
  return dayjs(date)
    .utc(true)
    .add(1, 'month')
    .endOf('month')
    .startOf('day')
    .toDate()
}

export function timezonedDateIsSameDayOfIsoDate(
  timezonedDate?: Date | string | number,
  isoDate?: Date | string | number,
): boolean {
  if (!timezonedDate || !isoDate) {
    return false
  }

  const _timezonedDate = dayjs(timezonedDate).startOf('day').utc(true)
  const _isoDate = dayjs.utc(isoDate).startOf('day')
  return dayjs(_timezonedDate).isSame(_isoDate)
}
